<template>
  <BaseTableView :head="tableHead" list-view="lgAndUp">
    <slot/>
  </BaseTableView>
</template>

<script>
import BaseTableView from "components/base/tableview/BaseTableView";

export default {
  name: "FinanceSalarySliceTable",
  components: {BaseTableView},
  data: () => ({
    tableMin: false,
  }),
  computed: {
    tableHead() {
      return [
        {text: this.localStorage.translations.pages.finance['salary-table'].period},
        {text: this.localStorage.translations.pages.finance['salary-table'].weeks},
        {text: this.localStorage.translations.pages.finance['salary-table'].status},
        {text: '', active: true}
      ]
    }
  },
  methods: {
    onMin(value) {
      this.tableMin = value
    },
  }
}
</script>
